import { Nullable } from 'types'
import { GraphQLError } from 'graphql'
import { IGraphQLErrorExtraDataParams, IGraphQLResponseWithError } from './types'

export function graphQLErrorExtraData(extraDataParams: IGraphQLErrorExtraDataParams = {}) {
  const result: { [key: string]: Nullable<string> } = {
    query: extraDataParams.query,
    variables: extraDataParams.variables,
    cookie: extraDataParams.cookie,
    response: extraDataParams?.response,
  }

  if (extraDataParams.requestParameters) {
    result.query = extraDataParams.requestParameters.text || result.query
    // TODO: figure out if cacheID was actually removed, or it's the typings that are wrong
    result.relayCacheID = (extraDataParams.requestParameters as any).cacheID
    result.relayOperationName = extraDataParams.requestParameters.name
    result.relayOperationKind = extraDataParams.requestParameters.operationKind
    result.relayId = extraDataParams.requestParameters.id
    result.relayMetadata = JSON.stringify(extraDataParams.requestParameters.metadata)
  }

  return result
}

export function hasGraphQLErrors(response: any): response is IGraphQLResponseWithError {
  if (!response) return false

  const errors = response?.errors || [] as GraphQLError[]

  return Boolean(Array.isArray(errors) && errors?.length > 0 && errors[0].message)
}
